export default __webpack_public_path__ + "static/media/tech.ccf77a42.webp";